<script setup lang="ts">
import DashboardLayout from '~/layouts/DashboardLayout.vue';

const iframeUrl = `${import.meta.env.VITE_RULE_ENGINE_API_URL}category/0dbfb545-51f1-499b-a5d8-fb1082c8cfbd`;
</script>

<template>
  <div class="financing-detail-bg">
    <DashboardLayout title="" description="">
      <div class="financing-header card mb-4 p-4 d-flex flex-row align-items-center gap-4">
        <iframe
          class="rule-engine-iframe"
          :src="iframeUrl"
          title="Rule Risk"
          frameborder="0"
          width="100%"
        />
      </div>
    </DashboardLayout>
  </div>
</template>

<style scoped lang="scss">
.rule-engine-iframe {
  min-height: 100vh;
}
.financing-detail-bg {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e9ecef 100%);
  padding: 32px 0 0 0;
}
.financing-header {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px 0 rgba(60, 72, 88, 0.08);
  border: none;
}
</style>
